import classNames from 'classnames'

import { Button } from 'core-components/library/button'

import styles from './Actions.module.scss'

interface IProps {
  className?: string
  themeKbase?: boolean
  type: 'edit' | 'done' | 'close'
  onClick: (e: any) => void
  disabled?: boolean
}

export const ActionBtn = ({ className, themeKbase, type, onClick, disabled }: IProps) => {
  return (
    <Button
      className={classNames(styles.root, themeKbase ? styles['root--kbase'] : '', className || '')}
      variant={themeKbase ? 'outlined' : type === 'close' ? 'outlined' : 'contained'}
      iconButton={classNames(styles.icon, 'kbase', {
        [classNames(styles['icon--done'], 'kbase-check')]: type === 'done',
        [classNames(styles['icon--close'], 'kbase-close')]: type === 'close',
        [classNames(styles['icon--edit'], 'kbase-edit')]: type === 'edit',
      })}
      onClick={onClick}
      disabled={disabled}
    />
  )
}
